export const SPECIAL_BUNDLE_NAME = 'Swag.com';
export const IS_TENANT_INVENTORY_ENABLED = true;